import React from "react";
import "./Loader.css";

const Loader = ({ text = "Loading market data..." }) => {
    return (
        <div className="loader-overlay">
            <div className="market-loader">

                <div className="bars">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <p>{text}</p>
            </div>
        </div>
    );
};

export default Loader;